/* ================== THE HOUSE RAIL ==================
   The Station's ad spots are for sale. Until a spot is sold, it runs
   a house ad rather than a "YOUR MARK HERE" placeholder — the studio
   that built the station, and the app it was built alongside.

   Rules this obeys:
   - A sold spot always wins. This never overwrites a real sponsor.
   - House ads are labelled HOUSE, so nobody thinks they are paid.
   - The spot is still for sale: every house ad keeps a quiet
     "this spot is for sale" affordance that opens the rate card.
   - Which creative shows rotates by page, by day, by hour band and
     by visit, so the same person does not see the same ad twice.
   ==================================================================== */
(function () {
  if (window.STATION_HOUSE) return;

  var PHI = 1.6180339887498948;

  /* ---- the creatives ------------------------------------------------ */
  var LUND = [
    { tag: 'BUILT BY', mark: 'LUND STUDIO',
      line: 'This whole station — theme, arcade, engines — built in-house.',
      cta: 'SEE THE WORK', url: 'https://lundstudio.co' },
    { tag: 'BUILT BY', mark: 'LUND STUDIO',
      line: 'Shopify themes that ship as one upload and carry the whole site.',
      cta: 'LUNDSTUDIO.CO', url: 'https://lundstudio.co' },
    { tag: 'FROM THE STUDIO', mark: 'THE DIVINITY RULE',
      line: 'φ = 1.618. Every proportion on this page answers to it.',
      cta: 'READ THE RULE', url: 'https://lundstudio.co' },
    { tag: 'FROM THE STUDIO', mark: 'RÓTA',
      line: 'The rotation engine behind this ad. Content that never sits still.',
      cta: 'LICENCE IT', url: 'https://lundstudio.co' },
    { tag: 'FROM THE STUDIO', mark: 'LUND CARDS',
      line: 'Drop a card into Claude and it builds the way the studio builds.',
      cta: 'SEE THE SUITE', url: 'https://lundstudio.co' },
    { tag: 'BUILT BY', mark: 'LUND STUDIO',
      line: 'Twenty-three browser machines on this deck. No engine, no downloads.',
      cta: 'HOW WE BUILD', url: 'https://lundstudio.co' }
  ];

  var SIDEREP = [
    { tag: 'ALSO FROM THE HOUSE', mark: 'SIDEREP',
      line: 'Your club, your crew, your season — in one app.',
      cta: 'SIDEREP.TECH', url: 'https://siderep.tech' },
    { tag: 'ALSO FROM THE HOUSE', mark: 'SIDEREP · CLUBS',
      line: 'Start a club, run the board, keep the crew moving together.',
      cta: 'OPEN A CLUB', url: 'https://siderep.tech' },
    { tag: 'ALSO FROM THE HOUSE', mark: 'SIDEREP · COACHING',
      line: 'Coaching that reads the week you actually had, not the one you planned.',
      cta: 'SEE COACHING', url: 'https://siderep.tech' },
    { tag: 'ALSO FROM THE HOUSE', mark: 'SIDEREP · THE FORGE',
      line: 'Design your own kit — full wrap, print-ready, no minimum of ninety.',
      cta: 'BUILD A KIT', url: 'https://siderep.tech' },
    { tag: 'ALSO FROM THE HOUSE', mark: 'SIDEREP · THE SCANNER',
      line: 'Point it at your gear. It knows what it is looking at.',
      cta: 'TRY THE SCANNER', url: 'https://siderep.tech' },
    { tag: 'ALSO FROM THE HOUSE', mark: 'SIDEREP · THE BOARD',
      line: 'Every state gets its own board. Yours is probably empty. Go first.',
      cta: 'CLAIM YOUR STATE', url: 'https://siderep.tech' }
  ];

  /* the vessels advertise themselves on the free decks — the shop is the point */
  var SHOP = [
    { tag: 'THE STATION', mark: 'CLAIM YOUR COLOR',
      line: '22 oz · 100 per colour · $33 plus shipping · never made again.',
      cta: 'THE VESSEL BAY', url: '/#/bottles' }
  ];

  /* every slot can draw either house — weighted so the top of a page leans
     studio-and-shop and the lower spots lean SideRep, but none is locked */
  var POOL = {
    top:  SHOP.concat(LUND, SIDEREP.slice(0, 2)),
    mid:  SIDEREP.concat(LUND.slice(0, 3)),
    foot: LUND.concat(SIDEREP, SHOP)
  };

  /* ---- the dial: page × day × band × visit, so nothing repeats ------- */
  function hash(s) {
    var h = 2166136261 >>> 0;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function band() { var h = new Date().getHours(); return h < 6 ? 0 : h < 11 ? 1 : h < 17 ? 2 : h < 21 ? 3 : 0; }
  function day() { var d = new Date(); return Math.floor(d / 86400000); }
  function visit(slot) {
    var k = 'house.visit.' + slot, n = 0;
    try { n = (parseInt(sessionStorage.getItem(k), 10) || 0) + 1; sessionStorage.setItem(k, n); }
    catch (e) { n = Math.floor(Math.random() * 1e6); }
    return n;
  }
  function pick(slot) {
    var pool = POOL[slot] || LUND;
    var seed = hash(location.pathname + '|' + slot + '|d' + day() + '|b' + band());
    var idx = (Math.floor(seed * PHI) + visit(slot)) % pool.length;
    return pool[idx];
  }

  /* ---- paint ---------------------------------------------------------
     Only ever fills a spot the site itself has marked open. A sold spot
     carries .filled and is left exactly as it is. */
  function paint() {
    ['top', 'mid', 'foot'].forEach(function (slot) {
      var el = document.getElementById('tier-' + slot);
      if (!el || el.classList.contains('filled') || el.dataset.house === '1') return;
      if (el.innerHTML.indexOf('YOUR MARK HERE') < 0) return;   /* someone sold it — leave it */

      var ad = pick(slot);
      var tag = el.querySelector('.tag') ? el.querySelector('.tag').outerHTML : '';
      el.dataset.house = '1';
      el.classList.add('house');
      el.innerHTML = tag +
        '<div><div class="mark">' + ad.mark + '</div>' +
        '<div class="line">' + ad.line + '</div></div>' +
        '<div class="price"><span>' + ad.tag + ' · HOUSE</span><b style="font-size:12px">' + ad.cta + ' →</b></div>';

      el.onclick = function (e) {
        if (e.target && e.target.closest && e.target.closest('.house-sale')) return;
        window.open(ad.url, ad.url.charAt(0) === '/' ? '_self' : '_blank', 'noopener');
      };
      el.style.cursor = 'pointer';

      /* the spot is still for sale — keep the door open, quietly */
      var sale = document.createElement('button');
      sale.type = 'button';
      sale.className = 'house-sale';
      sale.textContent = 'this spot is for sale';
      sale.onclick = function (e) {
        e.stopPropagation();
        if (typeof window.sponsorModal === 'function') window.sponsorModal();
        else window.location.href = '/pages/partners';
      };
      el.appendChild(sale);
    });
  }


  /* ---- the main site's spots are CARDS, not bars ----------------------
     The Fuel Bay and the Garment Hold each render "PARTNER SPOT · OPEN"
     placeholders. Fill all but the last one in each rail with house ads,
     so the rail still visibly has room for a real partner. */
  function adCard(ad, kindLabel, slotLabel) {
    return '<article class="fuel-card house-card">' +
      '<div class="fuel-top"><span class="fuel-kind">' + kindLabel + '</span>' +
      '<span class="fuel-tag" style="color:#8A9AC0;border-color:#8A9AC0">HOUSE · ' + slotLabel + '</span></div>' +
      '<div class="fuel-brand">' + ad.mark + '</div>' +
      '<div class="fuel-name">' + ad.tag + '</div>' +
      '<p class="fuel-note">' + ad.line + '</p>' +
      '<div class="fuel-cta"><span class="fuel-price">—</span>' +
      '<a class="add" href="' + ad.url + '"' + (ad.url.charAt(0) === '/' ? '' : ' target="_blank" rel="noopener"') + '>' + ad.cta + ' →</a></div>' +
      '<span class="fuel-aff">house ad · this spot is for sale</span>' +
      '</article>';
  }

  function fillCards() {
    /* the fuel bay */
    var fuel = [].slice.call(document.querySelectorAll('.fuel-card'))
      .filter(function (c) { return /PARTNER SPOT/i.test(c.textContent) && !c.classList.contains('house-card'); });
    fuel.slice(0, Math.max(0, fuel.length - 1)).forEach(function (c, i) {
      var ad = pick(i === 0 ? 'top' : 'mid');
      c.outerHTML = adCard(ad, 'FROM THE HOUSE', 'SPOT ' + (i + 1));
    });

    /* the garment hold partner rail */
    var gh = [].slice.call(document.querySelectorAll('.gh-card.ps'))
      .filter(function (c) { return !c.classList.contains('house-card'); });
    gh.slice(0, Math.max(0, gh.length - 1)).forEach(function (c, i) {
      var ad = pick(i === 0 ? 'foot' : 'mid');
      c.classList.add('house-card');
      var st = c.querySelector('.gh-st'); if (st) { st.textContent = 'HOUSE'; st.style.setProperty('--st', '#8A9AC0'); }
      var nm = c.querySelector('.gh-nm'); if (nm) nm.textContent = ad.mark;
      var meta = c.querySelector('.gh-meta'); if (meta) meta.textContent = ad.line;
      var cta = c.querySelector('.gh-buy, .add, .gh-row a, .gh-row button');
      if (cta) {
        var a = document.createElement('a');
        a.className = 'gh-buy'; a.href = ad.url; a.textContent = ad.cta + ' \u2192';
        if (ad.url.charAt(0) !== '/') { a.target = '_blank'; a.rel = 'noopener'; }
        cta.parentNode.replaceChild(a, cta);
      }
    });
  }

  function paintAll(){ paint(); fillCards(); }

  window.STATION_HOUSE = { paint: paintAll, pools: POOL, cards: fillCards };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(paintAll, 60); });
  else setTimeout(paintAll, 60);
  /* the tier bars are rendered by the page's own script — repaint once it has run */
  setTimeout(paintAll, 400);
  setTimeout(paintAll, 1200);
  setTimeout(paintAll, 2400);
})();
